(function () {
    'use strict';

    angular.module("imApp").factory("productPricesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 643,
                    parameters: parms || {}
                });
            },
            listPriceGroups: function (parms) {
                return $ihttp.post({
                    method: 645,
                    parameters: parms || {}
                });
            },
            listRelatedToPriceGroups: function (parms) {
                return $ihttp.post({
                    method: 646,
                    parameters: parms || {}
                });
            },
            listRelatedToProductSizes: function (parms) {
                return $ihttp.post({
                    method: 647,
                    parameters: parms || {}
                });
            },
            getProductPriceSettings: function (setting) {
                return $ihttp.post({
                    method: 644,
                    parameters: setting
                });
            },
            setActivePrice: function (setting) {
                return $ihttp.post({
                    method: 659,
                    parameters: setting
                });
            },
            refreshItems: function (setting) {
                return $ihttp.post({
                    method: 3857,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
